<div class="flex w-102.75">
    <section class="w-full">
        <article id="header" class="flex primary-green-2-background rounded-ss-lg rounded-se-lg">
            <div class="flex ml-5 my-4 items-center w-full">
                <h1 class="font-bold text-[22px] primary-purple-text">{{ literalService.get('services.title', true) }}</h1>
            </div>
            <div class="flex items-center mr-8">
                <img id="gtfsImportIcon" [src]="images.services.import" alt="gtfsImport" (click)="showGTFs($event)" class="w-5 h-5 mr-3 cursor-pointer" [tooltip]="literalService.get('services.tooltips.import', true)" [position]="TooltipPosition.ABOVE" />
                <img id="gtfsExportIcon" [src]="images.services.export" alt="gtfsExport" (click)="openExportGTFSModal.emit()" class="w-6 h-6 mr-2 cursor-pointer" [tooltip]="literalService.get('services.tooltips.downloadGTFS', true)" [position]="TooltipPosition.ABOVE" />
                <img [src]="images.services.addService" alt="addService" (click)="addService.emit()" class="w-6 h-6 mr-2 cursor-pointer" [tooltip]="literalService.get('services.tooltips.newService', true)" [position]="TooltipPosition.ABOVE" />
            </div>
            <div id="gtfsOptions" class="absolute w-52 primary-purple-light-2-background z-50 rounded-lg" [ngClass]="{'fadeIn': showGTFsOptions, 'fadeOut': !showGTFsOptions}">
                <div class="p-4">
                    <button (click)="openGTFSModal.emit()" class="flex w-full rounded bg-white pr-4 pl-2 py-2 mb-2 cursor-pointer items-center">
                        <label class="cursor-pointer">{{ literalService.get('services.actions.importGTFS', true) }}</label>
                    </button>
                    <button (click)="openImportCSVModal.emit()" class="flex w-full rounded bg-white pr-4 pl-2 py-2 mb-2 cursor-pointer items-center">
                        <label class="cursor-pointer">{{ literalService.get('services.actions.importCSV', true) }}</label>
                    </button>
                </div>
            </div>
        </article>
        <article id="search" class="flex bg-white">
            <div class="mx-5 my-4 items-center w-full">
                <app-service-search-bar
                    [placeholder]="literalService.get('services.search', true)"
                    [searching]="searching"
                    [searchValue]="searchValue"
                    (searchEventEmitter)="search($event)">
                </app-service-search-bar>
            </div>
        </article>
        <article id="body" class="flex bg-white">
            <div class="mx-5 my-5 items-center min-w-92.75 max-w-92.75">
                @if (!serviceInfos().isFetchingServiceInfos) {
                    @for (serviceInfo of serviceInfos().value; track $index) {
                        <div class="row">
                            <app-service-row [service]="serviceInfo" [index]="$index" [serviceInfoSelected]="serviceInfoSelected()" (showServiceInfoData)="selectServiceInfo.emit(serviceInfo)" (showRoutes)="showRoutes.emit(serviceInfo)"></app-service-row>
                        </div>
                    }
                } @else {
                    <ngx-skeleton-loader [count]="serviceInfos().pagination.numberOfElements || 6" appearance="line" [theme]="{ 'height': '50px', 'margin-bottom': '4px' }"></ngx-skeleton-loader>
                }
            </div>
        </article>
        <article id="footer" class="flex items-center bg-white rounded-es-lg rounded-ee-lg pb-17.5">
            <!-- <label>{{ serviceInfos().pagination.numberOfElements }}</label> -->
            <app-pagination id="serviceInfoPagination" [id]="'serviceInfoPagination'" class="mx-5" [pagination]="serviceInfos().pagination" [loading]="serviceInfos().isFetchingServiceInfos && !serviceInfos().pagination.totalPages" [baseUrl]="'/services'" (changePage)="changePageService($event)" [small]="true" [maxLength]="5" [right]="false" />
        </article>
    </section>
</div>
  